import { render } from "./overall-summary-section.vue?vue&type=template&id=62d43124&scoped=true&ts=true"
import script from "./overall-summary-section.vue?vue&type=script&lang=ts"
export * from "./overall-summary-section.vue?vue&type=script&lang=ts"

import "./overall-summary-section.vue?vue&type=style&index=0&id=62d43124&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62d43124"]])

export default __exports__